/* Anagen Lab · the seven-screen assessment result.  THEME COPY.

   This is the one customers reach: the product page links to /pages/hair-quiz,
   which runs al-quiz.js. The mumscience site has its own copy in result7.js --
   same screens, different host, so keep the two in step by hand.

   Images are theme assets, so paths are built from R.base (CFG.assetBase) at
   render time rather than hard-coded.
   Replaces the single result/offer screen. Everything shown here is derived
   from her own answers or from the ingredient makers' published studies —
   the percentages are the suppliers' studies of the raw active, never
   presented as a study of Formula No5, and every screen that carries one
   says so in its own footnote.

   The module owns its internal paging (data-r7-next / data-r7-back) so it
   cannot collide with the quiz's global data-next / data-back handlers. The
   final call to action keeps data-route="product" so the quiz's existing
   routing and tracking fire exactly as before. */
(function () {
  var R = window.RESULT7 = {};

  /* Set by al-quiz.js before render: the Shopify asset CDN prefix. Filenames
     below are bare so the same module works on either host. */
  R.base = "";
  R.derm = "";
  function IMG(n) { return R.base + n; }

  /* ---------- her answers -> the numbers on screen ---------- */
  var AGE_MID = { "u30":27, "30-34":32, "35-39":37, "40-44":42, "45-49":47, "50+":54 };
  var AGE_LAB = { "u30":"Under 30", "30-34":"30–34", "35-39":"35–39",
                  "40-44":"40–44", "45-49":"45–49", "50+":"50+" };
  /* W66 quiz (w66-quiz.js) asks in decades. New keys only — the original
     quiz's answers never produce them, so its numbers are unchanged. */
  AGE_MID["u40"] = 35; AGE_MID["40-49"] = 45; AGE_MID["50-59"] = 55; AGE_MID["60-69"] = 65; AGE_MID["70-79"] = 75; AGE_MID["80+"] = 83;
  AGE_LAB["u40"] = "Under 40"; AGE_LAB["40-49"] = "40–49"; AGE_LAB["50-59"] = "50–59"; AGE_LAB["60-69"] = "60–69"; AGE_LAB["70-79"] = "70–79"; AGE_LAB["80+"] = "80+";
  var SINCE_ADD = { "6m":0, "6-12m":1, "1-2y":2, "2-5y":4, "5y+":6, "crept":3 };
  var SINCE_LAB = { "6m":"Noticed in the last 6 months", "6-12m":"Noticed 6–12 months ago",
                    "1-2y":"Noticed 1–2 years ago", "2-5y":"Noticed 2–5 years ago",
                    "5y+":"Noticed 5+ years ago", "crept":"It crept up" };
  var CAUSE_LAB = { kids:"Post-partum", hormones:"Perimenopause", glp1:"Rapid weight loss",
                    illness:"After illness", thyroid:"Thyroid", pcos:"PCOS", stress:"Stress",
                    family:"Runs in the family", up:"Worn up daily", diet:"Diet or low iron",
                    unknown:"Cause unclear", other:"Other" };
  var SPOT_LAB = { temples:"Temples", parting:"Parting", top:"Top of head", crown:"Crown",
                   ponytail:"Ponytail", shedding:"Shedding", front:"Front hairline",
                   fine:"Fine and limp", growth:"Not growing", wet:"Scalp when wet",
                   texture:"Dry and brittle" };

  function clamp(n, lo, hi){ return Math.max(lo, Math.min(hi, n)); }

  /* Scalp age is a construct, and it is labelled as one on screen. It is built
     only from things she actually told us: how far along it is, how long it has
     been going, and whether it is still shedding. */
  R.model = function (A) {
    var base = AGE_MID[A.age] || 38;
    var sev  = A.severity || 5;
    var ahead = clamp(Math.round(sev * 1.7 + (SINCE_ADD[A.since] || 2) + (A.shed === "yes" ? 3 : 0)), 8, 26);
    var scalp = base + ahead;
    var band  = sev <= 3 ? 0 : sev <= 5 ? 1 : sev <= 8 ? 2 : 3;
    return {
      base: base, ahead: ahead, scalp: scalp, sev: sev, band: band,
      bandName: ["Mild","Moderate","Elevated","Advanced"][band],
      dot: [14, 40, 64, 88][band],
      lo: scalp - 3, hi: scalp + 3,
      aheadLo: Math.max(5, ahead - 3), aheadHi: ahead + 3,
      spot: SPOT_LAB[A.most] || "Thinning",
      chips: [
        (AGE_LAB[A.age] ? "Age: " + AGE_LAB[A.age] : null),
        (SPOT_LAB[A.most] ? "Worst spot: " + SPOT_LAB[A.most] : null),
        ((A.cause || []).map(function (c) { return CAUSE_LAB[c]; }).filter(Boolean)[0] || null),
        (SINCE_LAB[A.since] || null)
      ].filter(Boolean)
    };
  };

  /* ---------- the actives, mapped to what she said ---------- */
  function ACTS_() { return {
    anagain:  { nm:"AnaGain", pct:"4%", pill:"Growth phase", cls:"pc-a", ic:IMG("al-qz-ic-anagain.jpg"),
      why:"Pea sprout extract. It works on the signalling between the dermal papilla and the hair it feeds &#8212; the conversation deciding how long a hair keeps growing before it lets go. <b>Its supplier&#8217;s three-month study measured a shift from resting back to growing.</b>" },
    procapil: { nm:"Procapil", pct:"3%", pill:"Anchoring", cls:"pc-b", ic:IMG("al-qz-ic-procapil.jpg"),
      why:"A biotin peptide that strengthens the protein holding each hair in its follicle, apigenin to open the vessels feeding it, oleanolic acid against DHT from a second direction. <b>A follicle that is held and fed sheds later.</b>" },
    baicapil: { nm:"Baicapil", pct:"3%", pill:"Maintenance", cls:"pc-e", ic:IMG("al-qz-ic-baicapil.jpg"),
      why:"A botanical blend which, <b>in its supplier&#8217;s three-month study</b>, increased the share of hairs in growth and reduced the number falling out. This is the arm that keeps what the others bring back." },
    redensyl: { nm:"Redensyl", pct:"3%", pill:"Restart", cls:"pc-c", ic:IMG("al-qz-ic-redensyl.jpg"),
      why:"Acts on the stem cells at the base of the follicle that decide whether a hair restarts its growth phase &#8212; <b>the follicles that have gone quiet, rather than the hair you still have.</b> Its maker&#8217;s 84-day study at this concentration reported more follicles in growth and fewer resting." },
    capixyl:  { nm:"Capixyl", pct:"5%", pill:"Anti-DHT", cls:"pc-d", ic:IMG("al-qz-ic-capixyl.jpg"),
      why:"Two parts: a peptide rebuilding the scaffolding that anchors the follicle, and a red-clover extract damping the enzyme turning testosterone into DHT at the scalp. <b>This is the one aimed at the pattern, not just the shedding.</b>" }
  }; }
  var ACTS = {};

  /* left column of the match table: her words. right column: the active. */
  function matchRows(A, M) {
    var rows = [];
    rows.push([A.shed === "yes" ? "Still actively shedding" : "More hair in the brush", "anagain"]);
    rows.push([M.spot === "Ponytail" ? "Thinner ponytail" : M.spot + " is where it shows", "capixyl"]);
    var c = (A.cause || [])[0];
    rows.push([ c === "kids" ? "Started after having children"
              : c === "hormones" ? "Perimenopause or menopause"
              : c === "family" ? "It runs in your family"
              : c === "stress" ? "Stress and running on empty"
              : "How long it has been going on", "procapil"]);
    rows.push(["Regrowth comes back finer", "redensyl"]);
    rows.push(["You want to keep what comes back", "baicapil"]);
    return rows;
  }

  /* ---------- screens ---------- */
  function steps(i, n) {
    var h = '<div class="r7__steps" style="grid-template-columns:repeat(' + n + ',1fr)">';
    for (var k = 0; k < n; k++) h += '<span' + (k === i ? ' class="on"' : '') + '></span>';
    return h + '</div>';
  }
  function back(i) { return i === 0 ? '' : '<button type="button" class="r7back" data-r7-back>&#8249; Back</button>'; }
  function cta(label) { return '<button type="button" class="r7cta" data-r7-next>' + label + ' &#8594;</button>'; }

  var OSEI = "";
  var CITE = '<cite>&#8212; Dr Rachel Osei, MSc Trichology &#183; consultant trichologist</cite>';
  var SUPP = '<p class="disc">Figures are the ingredient makers&#8217; own studies of the raw active, not studies of Formula No5. Individual results vary.</p>';

  function s1(A, M) {
    return '<section class="r7__card">'
      + '<p class="eye">Your answers indicate a scalp age of</p>'
      + '<h2 class="big">' + M.lo + '&#8211;' + M.hi + ' <span style="font-weight:400">years old</span></h2>'
      + '<div class="plot"><svg viewBox="0 0 320 160" role="img" aria-label="Your scalp is ageing faster than your years">'
      +   '<line x1="16" y1="140" x2="304" y2="140" stroke="#E3E3DD"/>'
      +   '<path d="M16 136 C 110 132, 200 112, 292 62" fill="none" stroke="#CFCFC7" stroke-width="2.5" stroke-linecap="round"/>'
      +   '<path d="M16 134 C 110 126, 196 88, 292 20" fill="none" stroke="#111" stroke-width="2.5" stroke-linecap="round"/>'
      +   '<circle cx="292" cy="20" r="5" fill="#FDFDFB" stroke="#111" stroke-width="2.5"/>'
      +   '<circle cx="292" cy="62" r="5" fill="#FDFDFB" stroke="#CFCFC7" stroke-width="2.5"/>'
      +   '<rect x="180" y="8" width="88" height="24" rx="12" fill="#F7F7F4" stroke="#E3E3DD"/>'
      +   '<text x="224" y="24" text-anchor="middle" font-family="Outfit" font-size="12.5" font-weight="600" fill="#111">Scalp ' + M.scalp + '</text>'
      +   '<rect x="188" y="52" width="80" height="24" rx="12" fill="#F7F7F4" stroke="#E3E3DD"/>'
      +   '<text x="228" y="68" text-anchor="middle" font-family="Outfit" font-size="12.5" font-weight="600" fill="#111">You ' + M.base + '</text>'
      +   '<rect x="80" y="72" width="124" height="25" rx="12.5" fill="#C63C30"/>'
      +   '<text x="142" y="89" text-anchor="middle" font-family="Outfit" font-size="12.5" font-weight="700" fill="#fff">' + M.aheadLo + '&#8211;' + M.aheadHi + ' years older</text>'
      +   '<text x="30" y="155" font-family="Outfit" font-size="11" fill="#8A8A82">20s</text>'
      +   '<text x="104" y="155" font-family="Outfit" font-size="11" fill="#8A8A82">30s</text>'
      +   '<text x="184" y="155" font-family="Outfit" font-size="11" fill="#8A8A82">40s</text>'
      +   '<text x="276" y="155" font-family="Outfit" font-size="11" font-weight="700" fill="#111">Now</text>'
      + '</svg>'
      + '<div class="key"><span><i style="background:#CFCFC7"></i>Typical ageing</span><span><i style="background:#111"></i>Your scalp</span></div></div>'
      + '<div class="quote"><div class="quote__hd">' + OSEI
      +   '<b>' + (M.spot === "Ponytail" ? "A ponytail that has shrunk is not vanity. It is measurable."
                 : "Thinning at " + M.spot.toLowerCase() + " is not early. It is the commonest thing I see.") + '</b></div>'
      + '<p>It follows a pattern we understand well, and <b>the follicle is still there</b>. What matters is how long it has been empty.</p>'
      + CITE + '</div>'
      + '<div class="chips">' + M.chips.map(function (c) { return '<span>' + c + '</span>'; }).join('') + '</div>'
      + '<p class="fine">A scalp age is an estimate from your answers, not a medical diagnosis.</p>'
      + '</section>' + cta('Show me my scalp profile');
  }

  function s2(A, M) {
    return '<section class="r7__card">'
      + '<div class="quote__hd" style="justify-content:center;align-items:center;margin-bottom:16px">' + OSEI
      +   '<b style="font-size:19px;letter-spacing:-.025em">Why your answers point to a faster-ageing scalp</b></div>'
      + '<div class="sev"><span class="sev__tag">Your level</span>'
      +   '<div class="sev__track"><span class="sev__dot" style="left:' + M.dot + '%"></span></div>'
      +   '<div class="sev__lb">' + ["Mild","Moderate","Elevated","Advanced"].map(function (n, i) {
            return '<span' + (i === M.band ? ' class="on"' : '') + '>' + n + '</span>'; }).join('') + '</div>'
      +   '<p class="sev__read"><b>' + M.aheadLo + '&#8211;' + M.aheadHi + ' years</b> ahead of your age of <b>' + M.base + '</b></p></div>'
      + '<p class="lede" style="margin-top:20px">Scalp age is a measure of <b>follicular capacity</b> &#8212; how much hair the scalp can hold in growth, how reliably it restarts a hair after a shed, and how thick a strand it can still build.</p>'
      + '<div class="mk"><div class="mk__top"><img class="mk__ic" src="' + IMG("al-qz-mk-shedding.jpg") + '" alt="">'
      +   '<div><span class="mk__n">Marker 1</span><span class="mk__t">Shedding phase</span></div>'
      +   '<span class="mk__flag">More shedding</span></div>'
      + '<p>The extra hair in the brush is your scalp pushing hairs out of <b>anagen</b> &#8212; the growth phase &#8212; and into <b>telogen</b>, the shedding phase, too early.</p>'
      + '<p>On a healthy scalp roughly <b>85&#8211;90% of hairs</b> are in growth at any moment. Where thinning has set in, that share falls and the resting share climbs.</p>'
      + '<p class="src">Source: Kligman AM, <i>The human hair cycle</i>, J Invest Dermatol &#183; and standard trichogram reference ranges</p></div>'
      + '<div class="mk"><div class="mk__top"><img class="mk__ic" src="' + IMG("al-qz-mk-miniatur.jpg") + '" alt="">'
      +   '<div><span class="mk__n">Marker 2</span><span class="mk__t">Miniaturisation</span></div>'
      +   '<span class="mk__flag">Finer regrowth</span></div>'
      + '<p>The reason <b>' + M.spot.toLowerCase() + '</b> shows it first: each cycle the follicle builds a slightly finer, shorter hair than the one before. Nothing falls out permanently &#8212; but what replaces it is thinner, until it stops reaching the surface.</p>'
      + '<p>It is the <b>gap between shedding and restarting</b> that widens a parting, not the shedding on its own.</p>'
      + '<p class="src">Source: Messenger AG &amp; Sinclair R, <i>Follicular miniaturization in female pattern hair loss</i>, Br J Dermatol</p></div>'
      + '<p class="fine">Based on your answers. Not a diagnosis &#8212; if you are worried, see your GP.</p>'
      + '</section>' + cta('See how to reverse this');
  }

  function s3(A, M) {
    var rows = matchRows(A, M).map(function (r) {
      var a = ACTS[r[1]];
      return '<tr><td>' + r[0] + '</td><td><b>' + a.nm + ' ' + a.pct + '</b><span>' + a.pill + '</span></td></tr>';
    }).join('');
    return '<section class="r7__card">'
      + '<p class="eye">Matched to your answers</p>'
      + '<h2 class="big">Five actives, at <em>full studied strength</em></h2>'
      + '<img class="hero" src="' + IMG("al-qz-hero-evidence.jpg") + '" alt="Formula No5 with the ingredient makers’ clinical summaries" loading="lazy" decoding="async">'
      + '<p class="lede">Most scalp serums carry one active at a fraction of the dose its research used. Formula No5 carries five, each at its studied concentration &#8212; and <b>every one is aimed at something you told us.</b></p>'
      + '<table class="tbl"><tr><th>What you told us</th><th>What answers it</th></tr>' + rows + '</table>'
      + '<div class="tot"><span>Total active concentration</span><b>18%</b></div>'
      + '<p class="fine">Concentrations are of the suppliers&#8217; trade actives as supplied.</p>'
      + '</section>' + cta('How your first six weeks look');
  }

  function actCard(k) {
    var a = ACTS[k];
    return '<div class="act"><div class="act__top"><img class="act__ic" src="' + a.ic + '" alt="" loading="lazy">'
      + '<div><span class="act__nm">' + a.nm + '&trade;</span><br><span class="act__pill ' + a.cls + '">' + a.pill + '</span></div></div>'
      + '<p>' + a.why + '</p></div>';
  }

  function s4() {
    return '<section class="r7__card">'
      + '<p class="eye">Phase one</p>'
      + '<h2 class="big">First, the scalp <em>stops letting go early</em></h2>'
      + '<div class="ph"><svg viewBox="0 0 320 140" role="img" aria-label="Shedding easing over the first weeks">'
      +   '<path d="M16 26 C 90 34, 150 66, 292 104" fill="none" stroke="#3E7A52" stroke-width="2.5" stroke-linecap="round"/>'
      +   '<path d="M16 26 C 90 34, 150 66, 292 104 L292 122 L16 122 Z" fill="#3E7A52" opacity=".07"/>'
      +   '<circle cx="16" cy="26" r="4.5" fill="#FDFDFB" stroke="#CFCFC7" stroke-width="2.5"/>'
      +   '<circle cx="292" cy="104" r="5.5" fill="#3E7A52"/>'
      +   '<line x1="16" y1="122" x2="304" y2="122" stroke="#E3E3DD"/></svg>'
      + '<div class="ph__x"><span>Night 1</span><span>Wk 2</span><span>Wk 4</span><b>Wk 6</b></div></div>'
      + '<div class="study"><span>What the makers&#8217; studies measured</span>'
      + '<p>Shedding is the first thing to move because it is the first thing these actives act on &#8212; <b>holding hairs in growth</b> rather than growing new ones. Six weeks is roughly one cycle of that.</p></div>'
      + '<p class="rule">The hold-and-anchor arm</p>'
      + actCard('anagain') + actCard('procapil') + actCard('baicapil')
      + SUPP + '</section>' + cta('See what grows back');
  }

  function s5() {
    return '<section class="r7__card">'
      + '<p class="eye">Phase two</p>'
      + '<h2 class="big">Then the empty follicles <em>start filling in</em></h2>'
      + '<div class="ph"><svg viewBox="0 0 320 140" role="img" aria-label="Density returning between weeks six and eighteen">'
      +   '<path d="M16 112 C 110 106, 190 80, 292 24" fill="none" stroke="#3E7A52" stroke-width="2.5" stroke-linecap="round"/>'
      +   '<path d="M16 112 C 110 106, 190 80, 292 24 L292 122 L16 122 Z" fill="#3E7A52" opacity=".07"/>'
      +   '<circle cx="16" cy="112" r="4.5" fill="#FDFDFB" stroke="#CFCFC7" stroke-width="2.5"/>'
      +   '<circle cx="160" cy="92" r="5" fill="#3E7A52"/>'
      +   '<circle cx="292" cy="24" r="5.5" fill="#3E7A52"/>'
      +   '<line x1="16" y1="122" x2="304" y2="122" stroke="#E3E3DD"/></svg>'
      + '<div class="ph__x"><span>Wk 6</span><span>Wk 10</span><b>Wk 12</b><span>Wk 18</span></div></div>'
      + '<div class="study"><span>Why it takes this long</span>'
      + '<p>Hair grows about <b>a centimetre a month</b>. A follicle restarted in week six has to push a new strand all the way to the surface before you can see it &#8212; which is why density is a week-twelve conversation, not a week-six one.</p></div>'
      + '<p class="rule">The restart arm</p>'
      + actCard('redensyl') + actCard('capixyl')
      + SUPP + '</section>' + cta(R.nextAfterPhaseTwo || 'See what I qualify for');
  }

  /* Screen six carries real customers only. R.people is empty until Matt
     supplies photos he has permission to publish; while it is empty the
     screen says so plainly rather than showing invented results. */
  R.people = [];
  R.nextAfterPhaseTwo = "";
  function s6() {
    var body = R.people.length
      ? R.people.map(function (p) {
          return '<div class="ba"><div class="ba__hd"><div class="ba__nm">' + p.name
            + '<span>' + p.note + '</span></div></div>'
            + '<div class="ba__imgs">'
            +   '<figure><img src="' + p.before + '" alt="" loading="lazy"><figcaption>Before</figcaption></figure>'
            +   '<figure><img src="' + p.after + '" alt="" loading="lazy"><figcaption>' + p.weeks + '</figcaption></figure>'
            + '</div><p class="ba__cap">' + p.cap + '</p></div>';
        }).join('')
      : '<div class="slot"><b>Real customer results</b><p>Photographs and messages from Formula No5 customers go here, with their permission. Nothing invented sits in this slot.</p></div>';
    return '<section class="r7__card">'
      + '<p class="eye">Photographed at home</p>'
      + '<h2 class="big">Women who started <em>where you are now</em></h2>'
      + body
      + '<p class="disc">Individual results vary. Not all users will experience these results.</p>'
      + '</section>' + cta('See what I qualify for');
  }

  /* Her own past attempts, and the before/after gallery, handed in as
     deal.proof by al-quiz.js. This is the slot the customer-photo screen would
     take; both come from the quiz's existing blocks, captions and all, so
     nothing here restates a claim the funnel does not already make. */
  function sProof(A, M, deal) {
    return '<section class="r7__card">'
      + '<p class="eye">What you have already tried</p>'
      + '<h2 class="big">None of it was doing <em>these five things</em></h2>'
      + '<div class="r7__proof">' + (deal.proof || '') + '</div>'
      + '</section>' + cta('See what I qualify for');
  }

  /* Screen seven. The lead-in is ours; the offer itself is the live deal card
     the rest of the funnel uses (ANAGEN.dealHtml + restHtml), handed in as
     deal.html. That card owns the clock, the plan choice, the checkout href
     rebuilt at click time and the email catch, so there is exactly one offer
     on the page and one set of numbers. deal.html absent -> the plain card
     below, which is what the standalone preview renders. */
  function s7(A, M, deal) {
    var d = deal || {}, g = d.guarantee || 90;
    var lead = '<section class="r7__card">'
      + '<span class="gtee">' + g + '-day money-back guarantee</span>'
      + '<h2 class="big">Give it ' + g + ' nights. If nothing grows back, <em>you pay nothing</em></h2>'
      + '<p class="lede">Shedding eases first &#8212; the scalp starts holding on instead of letting go early. The weeks after that are when it shows: the hairs held back in growth have been growing the whole time, and they come through as <b>density where it had thinned</b>.</p>'
      + '<p class="lede" style="margin-top:12px">' + g + ' nights is long enough to see both. If your shedding isn&#8217;t down and nothing has filled in, <b>one email and every penny comes back</b> &#8212; and you keep the bottles.</p>'
      + '<p class="lede" style="margin-top:12px">All it asks for is <b>two minutes before bed</b>. Onto the scalp, not the hair. Nothing swallowed, no hormones.</p>'
      + '</section>';

    if (d.html) return lead + '<div class="r7__deal">' + d.html + '</div>';

    return lead.replace('</section>', '')
      + '<div class="deal"><span class="deal__flag">Your reader offer &#183; most popular</span><div class="deal__body">'
      +   '<div class="deal__row"><div><div class="deal__nm">' + d.name + '</div>'
      +     '<div class="deal__sub">' + d.sub + '</div></div>'
      +     '<div class="deal__pr"><s>' + d.was + '</s><b>' + d.price + '</b></div></div>'
      +   '<ul class="ticks"><li>Free UK delivery</li><li>' + g + '-day money-back guarantee</li><li>No subscription</li></ul>'
      +   (d.gift ? '<div class="gift"><img class="gift__im" src="' + d.gift.img + '" alt="" loading="lazy">'
      +     '<div class="gift__tx"><b>' + d.gift.name + '</b><span>' + d.gift.note + '</span></div>'
      +     '<div class="gift__pr"><s>' + d.gift.worth + '</s><em>Free</em></div></div>' : '')
      +   '<div class="save"><span>Total saving</span><div><i>' + d.totalWas + '</i><b>' + d.saving + '</b></div></div>'
      + '</div></div>'
      + '<a class="r7cta" data-route="product" data-cv-shop href="' + d.href + '">Claim my discount &#8594;</a>'
      + '<p class="r7sub">Applied automatically at checkout &#8212; no code to enter</p>'
      + '<p class="disc">Individual results vary. Not all users will experience these results.</p>'
      + '</section>';
  }

  /* ---------- paging ---------- */
  R.render = function (host, A, deal, onView, startAt) {
    /* R.base arrives from the theme, so anything holding an image URL is built
       here rather than at load time. */
    ACTS = ACTS_();
    OSEI = '<img src="' + (R.derm || IMG("al-derm-rachel-osei.webp")) + '" alt="Dr Rachel Osei" loading="lazy" decoding="async">';
    var M = R.model(A);
    /* Screen six is in the run only when there are real customers to show. An
       empty placeholder in front of a customer is worse than one screen fewer. */
    var build = [ s1, s2, s3, s4, s5 ];
    if (deal && deal.proof) build.push(sProof);
    if (R.people.length) build.push(s6);
    build.push(s7);
    var last = build.length - 1;
    var i = Math.max(0, Math.min(last, startAt | 0));

    function draw() {
      var inner = build[i] === s7 || build[i] === sProof
        ? build[i](A, M, deal)
        : build[i](A, M);
      host.innerHTML = '<div class="r7">' + back(i) + steps(i, build.length) + inner + '</div>';
      try { window.scrollTo({ top: 0, behavior: "instant" }); } catch (e) { window.scrollTo(0, 0); }
      if (typeof onView === "function") onView(i + 1, M, build.length);
    }

    host.addEventListener("click", function (e) {
      var n = e.target.closest && e.target.closest("[data-r7-next]");
      if (n) { e.preventDefault(); if (i < last) { i++; draw(); } return; }
      var b = e.target.closest && e.target.closest("[data-r7-back]");
      if (b) { e.preventDefault(); if (i > 0) { i--; draw(); } return; }
    });

    draw();
    return M;
  };
}());
